import { get, isNil } from 'lodash-es'

import { isNotEmptyArray } from '@/utils'

export type Data = {
  [x: string]: any
}

type TextName = string | string[]

export const formatStr = (str: TextName): any => {
  return isNotEmptyArray(str) ? (str as string[]).join(' ') : isNil(str) ? '-' : str
}

export const textRender = (key: TextName, itemData: Data): string => {
  if (typeof key === 'string') {
    const formated = formatStr(get(itemData, key))
    return isNil(formated) ? '' : formated
  }
  if (isNotEmptyArray(key)) {
    return key.map((keyItem) => textRender(keyItem, itemData)).join(' ')
  }
  return ''
}

// 执行函数
export const execJsStr = (func: any, values: any, current?: any) => {
  if (!func) return func
  if (typeof func === 'function') {
    return func(values, current)
  } else if (typeof func === 'string') {
    // eslint-disable-next-line no-new-func
    const _func = new Function('values', 'current', `return ${func}`)
    return _func(values, current)
  }
  return func
}

// 动态规则函数
export const dynamicRule = (item: any, record: any) => {
  const { type_dynamic, dynamic_info } = item || {}
  if (!(type_dynamic === 'dynamic' && dynamic_info?.dynamics_value)) return true

  const { type, dynamics_value } = dynamic_info || {}
  // 动态数据控制按钮展示
  if (type === 'and') {
    return Object.entries(dynamics_value).every(([key, values]: any) => {
      return values.includes(record?.[key])
    })
  } else if (type === 'or') {
    return Object.entries(dynamics_value).some(([key, values]: any) => {
      return values.some((value: any) => record?.[key] === value)
    })
  }
  return true
}
